import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {resetEntity, resetPage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {forgottenPassword} from "../actions/session";
import {showModal} from "../actions/modal";
import {loadUser} from '../actions/users';
import {defaultState as entityDefaultState} from '../reducers/entity';
import UserDetail from '../components/user/UserDetail';
import {breadcrumbs, setPageTitle} from "../utils";

class UserDetailPage extends Component {

	constructor(props) {
		super(props);

		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentWillMount() {
		this.props.loadUser(this.props.match.params.userId)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.match.params.userId !== this.props.match.params.userId
			|| (nextProps.match.params.tab === 'detail' && this.props.match.params.tab !== 'detail')) {
			this.props.loadUser(nextProps.match.params.userId);
		}
	}

	componentWillUnmount() {
		this.props.resetEntity("user");
		this.props.resetPage("users");
		setPageTitle();
	}

	handleFetchEnums(enums, entityId = null) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				if (entityId) {
					this.props.loadEntityEnum(entityId, enums[i], {})
				} else {
					this.props.loadGeneralEnum(enums[i], {})
				}
			}
		}
	}

	handleTabSelect(tab) {
		this.props.history.push('/uzivatele/' + this.props.match.params.userId + '/' + tab)
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;
		const tab = params.tab || 'detail';

		const bc = [
			{url: '/uzivatele', title: 'Uživatelé'},
			{url: '/uzivatele/' + params.userId, title: entity && entity.item && entity.item.userId ? entity.item.lastName : '...', literal: true}
		];
		if (tab !== 'detail') {
			bc.push({url: '/uzivatele/' + params.userId + '/' + tab, title: tab});
		}
		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<UserDetail {...entity} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onShowModal={this.props.showModal}
					onForgottenPassword={this.props.forgottenPassword}/>
			</div>
		)
	}
}

UserDetailPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadUser: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	resetEntity: PropTypes.func.isRequired,
	forgottenPassword: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {users},
		enums,
		session
	} = state;

	const entity = users[ownProps.match.params.userId] || entityDefaultState;

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadUser,
	loadGeneralEnum,
	forgottenPassword,
	resetEntity,
	resetPage,
	showModal
})(UserDetailPage)


// WEBPACK FOOTER //
// ./src/containers/UserDetailPage.js